module.exports = __webpack_public_path__ + "img/6_ralph_d.bad04aed.png";